import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { euro } from "@/lib/i18n";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function Analytics() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/analytics/summary").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return <div className="text-muted-foreground">Caricamento…</div>;

  return (
    <div className="space-y-8" data-testid="analytics-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Analytics</div>
        <h1 className="font-display text-4xl font-black tracking-tighter mt-1">Le tue metriche</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatBox label="Fatturato pagato" value={euro(d.total_revenue, d.currency)} testid="an-revenue" />
        <StatBox label="Ordini pagati" value={d.total_orders} testid="an-orders" />
        <StatBox label="Scontrino medio" value={euro(d.avg_ticket, d.currency)} testid="an-avg" />
      </div>

      <div className="p-6 bg-card border border-border rounded-2xl">
        <div className="text-sm font-medium mb-4">Ultimi 7 giorni</div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={d.series_7d}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="date" fontSize={11} tickFormatter={(v) => v.slice(5)} />
              <YAxis fontSize={11} />
              <Tooltip formatter={(v) => euro(v, d.currency)} />
              <Line type="monotone" dataKey="revenue" stroke="#E07A5F" strokeWidth={3} dot={{ r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="p-6 bg-card border border-border rounded-2xl">
        <div className="text-sm font-medium mb-4">Top piatti</div>
        <div className="space-y-2">
          {d.top_items.length === 0 && <div className="text-muted-foreground italic">Nessun dato ancora.</div>}
          {d.top_items.map((it, i) => (
            <div key={i} className="flex justify-between text-sm" data-testid={`top-item-${i}`}>
              <span>{i + 1}. {it.name} <span className="text-muted-foreground">× {it.quantity}</span></span>
              <span className="font-display font-bold">{euro(it.revenue, d.currency)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function StatBox({ label, value, testid }) {
  return (
    <div className="p-6 bg-card border border-border rounded-2xl" data-testid={testid}>
      <div className="font-display text-3xl font-bold tracking-tight">{value}</div>
      <div className="text-xs text-muted-foreground mt-1">{label}</div>
    </div>
  );
}
